import { Button, Card, Checkbox, Col, Empty, Flex, Form, Input, InputNumber, List, message, Modal, notification, Row, Select, Space, Table, Upload } from "antd";
import { MinusCircleOutlined, PlusOutlined, UploadOutlined } from '@ant-design/icons';
import type { UploadFile, UploadProps } from 'antd';
import TextArea from "antd/es/input/TextArea";
import { useNavigate, useParams } from "react-router-dom";
import CkEditor from "./ckeditor/ckEditor";
import { useEffect, useMemo, useRef, useState } from "react";
import { Check, Feather } from "lucide-react";
import { fundInterface } from "../models/IFund";
import { useForm } from "antd/es/form/Form";
import { BudgetDataInterface } from "../models/IBudgetData";
import axios from "axios";
import React from "react";
import { Document, Page } from 'react-pdf';
import { formatNumber } from "./functionLater";

// Define the type for your uploaded files


export function BudgetReqFund(){
  const [form] = Form.useForm();
  const [disabledFields, setDisabledFields] = useState({});
  const [loading, setLoading] = useState(false);
  const ref = useRef();

  const [IsStudentBudget,setIsStudentBudget] = useState(true);
  const [project_type,setProject_type] = useState('');

  const [compensationItems, setCompensationItems] = useState<BudgetDataInterface[]>([]);
  const [OutcomeItems, setOutcomeItems] = useState<BudgetDataInterface[]>([]);
  const [ItemCost, setItemCost] = useState<BudgetDataInterface[]>([]);


  const [fundData,setfundData] = useState<fundInterface[]>([])
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [filename,setFilename] = useState('')
  const [openfile,setOpenFile] = useState(false)

  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);

  const [content,setContent]=useState('')
  const [expandedRowKeys, setExpandedRowKeys] = useState<string[]>([]);

  const [open,setopen] = useState(false)
  const handleCancel = ()=>{
        setopen(false)
      }

  const {CKEditors,getHTML} = CkEditor()
  const navigate = useNavigate();
  
  const handleMainInfo = () =>{
    navigate(`/VRIIS/BudgetReqInfo/${project_id}`)
  }

  const handleRemove = (uid: string,filename:any) => {
    setFileList((prevFileList) => prevFileList.filter(file => file.fileName !== uid));
    message.success('File removed successfully.');
    axios.delete(`${process.env.REACT_APP_BASE}/delPDF/${uid}/${project_id}`).then(Response=>
      {if(Response.status==200){
        fetchFiles();
      }}
    )
  };

  const handleExpand = (expanded: boolean, record: any) => {
    if (expanded) {
      
      setExpandedRowKeys([record.id]); // Expand only the clicked row
    } else {
      setExpandedRowKeys([]); // Collapse all rows
    }
  };

  const DownloadHandle = async (fileName: any) => {
    try {
      // Make API call to get the PDF data
      const response = await axios.get(`${process.env.REACT_APP_BASE}/get_pdf/${fileName}/${project_id}`, {
        responseType: 'blob', // This is crucial for handling binary data
      });

      // Create a Blob from the response
      const pdfBlob = new Blob([response.data], { type: 'application/pdf' });

      // Create a URL for the Blob
      const pdfUrl = window.URL.createObjectURL(pdfBlob);

      // Create a link to download the PDF
      const link = document.createElement('a');
      link.href = pdfUrl;

      // Extract the filename from the Content-Disposition header
      const contentDisposition = response.headers['content-disposition'];
      let name = 'downloaded-file.pdf'; // Fallback filename

      if (contentDisposition) {
        const filenameRegex = /filename[^*=]*=((['"]).*?\2|([^;\s]*))/; 
        const matches = filenameRegex.exec(contentDisposition);
        if (matches != null && matches[1]) {
          name = matches[1].replace(/['"]/g, ''); // Remove quotes if present
        }
      }

      link.setAttribute('download', name); // Set the filename

      // Append link to body and trigger click to download
      document.body.appendChild(link);
      link.click();

      // Cleanup: remove link and release object URL
      document.body.removeChild(link);
      window.URL.revokeObjectURL(pdfUrl);

      if(response.status === 200){
        message.success('Download File successfully');
      }else{
        message.error('ERROR, Download File unsuccessfully');
      }

      message.success('PDF downloaded successfully!');
    } catch (error) {
      console.error('Error downloading PDF:', error);
      message.error('Failed to download PDF.');
    } finally {
      setLoading(false);
    }
    
  };

  const beforeUpload = (file : any) => {
    const encodedFileName = encodeURIComponent(file.name);
    const newFile = new File([file], encodedFileName, { type: file.type });
    const isPDF = file.type === 'application/pdf';
    if (!isPDF) {
      message.error('โปรดอัพโหลดไฟล์ PDF เท่านั้น');
      return Upload.LIST_IGNORE;
    }
    return newFile;
  }
  
  const { project_id } = useParams();
  const handleLiteratureEditorChange = () =>{
    setContent(getHTML(ref))
  }


//  `${process.env.REACT_APP_BASE}/upload_pdf/${project_id}`
const props: UploadProps = {
  name: 'file',
  accept: ".pdf",
  action: `${process.env.REACT_APP_BASE}/upload_pdf/${project_id}`,
  multiple: true,
  listType: "text",
  showUploadList: true,
  onChange(info) {
    const updatedFileList = [...fileList];
    const { file, fileList: newFileList } = info;

    if (info.file.status !== 'uploading') {
      console.log(info.file, info.fileList);
    }
    if (info.file.status === 'done') {
      message.success(`${info.file.name} file uploaded successfully`);
      updatedFileList.push(file);
      setFileList(updatedFileList);
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }
  },
  onPreview(file) { // Add onPreview for downloading
    const downloadLink = document.createElement('a');
    downloadLink.href = file.url || `${process.env.REACT_APP_BASE}/get_pdf/${file.response.fileName}`;
    downloadLink.download = file.name;
    downloadLink.click();
  },
  progress: {
    strokeColor: {
      '0%': '#108ee9',
      '100%': '#87d068',
    },
    
    strokeWidth: 3,
    format: (percent) => percent && `${parseFloat(percent.toFixed(2))}%`,
  },
};

  const option1 =[
    {
      value:'ค่าตอบแทนผู้วิจัย',
      label:'ค่าตอบแทนผู้วิจัย '
    },
    {
      value:'ค่าตอบแทนที่ปรึกษา',
      label:'ค่าตอบแทนที่ปรึกษา '
    },
    {
      value:'ค่าตอบแทนผู้เชี่ยวชาญ',
      label:'ค่าตอบแทนผู้เชี่ยวชาญ '
    },{
      value:'ค่าตอบแทนผู้เชี่ยวชาญตรวจประเมินคุณภาพเครื่องมือ',
      label:'ค่าตอบแทนผู้เชี่ยวชาญตรวจประเมินคุณภาพเครื่องมือ '
    },{
      value:'ค่าตอบแทนอื่นๆ',
      label:'ค่าตอบแทนอื่นๆ'
    }
  ]
  const option2 =[
    {
      value:'ค่าประมวลผลข้อมูลด้วยเครื่องคอมพิวเตอร์',
      label:'ค่าประมวลผลข้อมูลด้วยเครื่องคอมพิวเตอร์ '
    },
    {
      value:'ค่าบันทึกข้อมูล',
      label:'ค่าบันทึกข้อมูล'
    },{
      value:'ค่าไปนำเสนอผลงานวิจัยและนวัตกรรม',
      label:'ค่าไปนำเสนอผลงานวิจัยและนวัตกรรม'
    },{
      value:'ค่าจัดทำรูปเล่ม',
      label:'ค่าจัดทำรูปเล่ม'
    },
    // {
    //   value:'ค่าใช้จ่ายในการเผยแพร่และตีพิมพ์ผลงานวิจัย',
    //   label:'ค่าใช้จ่ายในการเผยแพร่และตีพิมพ์ผลงานวิจัย'
    // },
    {
      value:'ค่าใช้จ่ายในการขอจริยธรรมการวิจัย',
      label:'ค่าใช้จ่ายในการขอจริยธรรมการวิจัย'
    },{
      value:'ค่าเก็บแบบสอบถาม',
      label:'ค่าเก็บแบบสอบถาม'
    },{
      value:'ค่าใช้จ่ายอื่น ๆ ที่เกิดขึ้นจริงตามความเหมาะสม',
      label:'ค่าใช้จ่ายอื่น ๆ ที่เกิดขึ้นจริงตามความเหมาะสม'
    }
  ]
  const option3 =[
    {
      value:'ค่าวัสดุ และอุปกรณ์การวิจัย',
      label:'ค่าวัสดุ และอุปกรณ์การวิจัย'
    },
    {
      value:'ค่าผลิตเอกสาร / แบบสอบถาม / งานวิจัยที่เกี่ยวข้อง',
      label:'ค่าผลิตเอกสาร / แบบสอบถาม / งานวิจัยที่เกี่ยวข้อง'
    },{
      value:'ค่าผลิตรายงานการวิจัยต้นฉบับ',
      label:'ค่าผลิตรายงานการวิจัยต้นฉบับ'
    },{
      value:'ค่าแฟลชไดรฟ์',
      label:'ค่าแฟลชไดรฟ์'
    },{
      value:'ค่าวัสดุอื่น ๆ',
      label:'ค่าวัสดุอื่น ๆ'
    }
  ]
  const onFinish = (values: any) => {
    console.log('Received values of form:', values);
  };


  const handleDetailChange = (index: number, value: string) => {
    const newItems = [...compensationItems];
    newItems[index].BudgetDetail = value;

    if(value=='ค่าตอบแทนผู้เชี่ยวชาญ'){
      newItems[index].BudgetType = 'ตัวเงิน(เบิกจ่าย)';
    }
     
    newItems[index].Budget = 0
    setCompensationItems(newItems);
  };
  const handleTypeChange = (index: number, value: string) => {
    const newItems = [...compensationItems];
    newItems[index].BudgetType = value;
    setCompensationItems(newItems);
  };

  
  const handleOutcomeTypeChange = (index: number, value: string) => {
    const newItems = [...OutcomeItems];
    newItems[index].BudgetType = value;
    setOutcomeItems(newItems);
  };
  const handleItemsTypeChange = (index: number, value: string) => {
    const newItems = [...ItemCost];
    newItems[index].BudgetType = value;
    setItemCost(newItems);
  };

  const handleOutcomeDetailChange = (index: number, value: string) => {
    const newItems = [...OutcomeItems];
    newItems[index].BudgetDetail = value;
    
    if(value === 'ค่าไปนำเสนอผลงานวิจัยและนวัตกรรม'){
      newItems[index].BudgetType = 'ไม่เป็นตัวเงิน(งบอ้อม)'
    }
    newItems[index].Budget = 0
    setOutcomeItems(newItems);
  };

  const handleitemcostBudgetDetailChange = (index: number, value: string) => {
    const newItems = [...ItemCost];
    newItems[index].BudgetDetail = value;
    // if(value === 'ค่าวัสดุ และอุปกรณ์การวิจัย'
    //   || value === 'ค่าผลิตเอกสาร / แบบสอบถาม / งานวิจัยที่เกี่ยวข้อง' 
    //   || value === 'ค่าผลิตรายงานการวิจัยต้นฉบับ'
    //   || value === 'ค่าแฟลชไดรฟ์' 
    //   || value === 'ค่าวัสดุอื่น ๆ'
    // ){
    //   newItems[index].BudgetType = 'ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้' 
    // }

    newItems[index].Budget = 0
    setItemCost(newItems);
  };
  
  const expandedRowRender = (record:any) => {
    let dataSource:  any[] | undefined = [];
    if (record.detail === 'หมวดค่าตอบแทน') {
      
        dataSource = compensationItems;
      
    } else if (record.detail === 'หมวดค่าใช้จ่าย') {
      dataSource = OutcomeItems;
    } else if (record.detail === 'หมวดค่าวัสดุ และอุปกรณ์') {
      dataSource = ItemCost;
    }
  
    return (
      <Table
        columns={[
          {
            title: '',
            width: 450, // Match parent table width
            dataIndex: 'BudgetDetail',
            key: 'BudgetDetail',
          },
          {
            title: '',
            width: 1000,
            children: [
              {
                title: '',
                dataIndex: 'MonetrySum',
                width: 200, // Match parent column
                render: (_, record) => (
                  <Flex justify="center">
                    {record.BudgetType === 'ตัวเงิน(เบิกจ่าย)'
                      ? formatNumber(record.Budget)
                      : '0.00'}
                  </Flex>
                ),
              },
              {
                title: '',
                dataIndex: 'PreparedSum',
                width: 200, // Match parent column
                render: (_, record) => (
                  <Flex justify="center">
                    {record.BudgetType === 'ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้'
                      ? formatNumber(record.Budget)
                      : '0.00'}
                  </Flex>
                ),
              },
              {
                title: '',
                dataIndex: 'IndirectSum',
                width: 200, // Match parent column
                render: (_, record) => (
                  <Flex justify="center">
                    {record.BudgetType === 'ไม่เป็นตัวเงิน(งบอ้อม)'
                      ? formatNumber(record.Budget)
                      : '0.00'}
                  </Flex>
                ),
              },
            ],
          },
          {
            title: '',
            width: 150, // Match parent "sum" column
            dataIndex: 'sum',
            render: (_, record) => (
              <Flex justify="center">{formatNumber(record.Budget)}</Flex>
            ),
          },
          {
            title: '',
            dataIndex: 'note',
            key: 'note',
            render: (text) => <div style={{ maxWidth: '500px' }}>{text}</div>,
          },
        ]}
        dataSource={dataSource}
        pagination={false}
        rowKey="budgetid"
        locale={{
          emptyText: <Empty description="ไม่มีข้อมูลรายละเอียด" />,
        }}
        showHeader={false}
      />
    );
  };
  
  

  const handleRemoveCompensation = (index: number) => {
    const newItems = compensationItems.filter((_, i) => i !== index);
    setCompensationItems(newItems);
  };
  const handleRemoveOutcome = (index: number) => {
    const newItems = OutcomeItems.filter((_, i) => i !== index);
    setOutcomeItems(newItems);
  };
  
  const handleRemoveItem = (index: number) => {
    const newItems = ItemCost.filter((_, i) => i !== index);
    setItemCost(newItems);
  };
  const handleAmountChange = (index: number, value: string) => {
    const newItems = [...compensationItems];
    
    // Convert to float while preserving valid number input
    const floatValue = parseFloat(value);
    
    // Ensure we do not set NaN, allow empty values
    newItems[index].Budget = value === "" ? 0 : floatValue;
    
    setCompensationItems(newItems);
  };
  
  const handleOutcomeAmountChange = (index: number, value: string) => {
    const newItems = [...OutcomeItems];
    newItems[index].Budget = Number(value) || 0; // Ensure it's a number
    setOutcomeItems(newItems);
  };
  const handleItemAmountChange = (index: number, value: string) => {
    const newItems = [...ItemCost];
    newItems[index].Budget = Number(value) || 0; // Ensure it's a number
    setItemCost(newItems);
  };
  

  const totalCompensation = compensationItems.reduce((sum, item) => sum + item.Budget, 0);
  const handleAddCompensation = () => {
    const x = compensationItems.length +1
    setCompensationItems([...compensationItems, { budgetid : x, BudgetDetail: '', itemAmount:0, BudgetType :'' , Budget: 0 , note: ''}]);
  };
  const totalOutcome = OutcomeItems.reduce((sum, item) => sum + item.Budget, 0);
  const handleAddOutcome = () => {
    const x = OutcomeItems.length
    setOutcomeItems([...OutcomeItems, { budgetid : x, BudgetDetail: '', BudgetType :'' , itemAmount:0, Budget: 0 , note: ''}]);
  };
  const totalItemCost = ItemCost.reduce((sum, item) => sum + item.Budget, 0);
  const handleAddItemCost = () => {
    const x = ItemCost.length
    setItemCost([...ItemCost, { budgetid : x, BudgetDetail: '', BudgetType :'' , itemAmount:0, Budget: 0 , note: ''}]);
  };

  function handleCompensationNoteChange(index: number, value: string) {
    // Create a new copy of the compensationItems array
    const updatedItems = [...compensationItems];
    
    // Update the note for the specific item
    updatedItems[index] = {
      ...updatedItems[index],
      note: value,
    };
  
    // Update the state with the modified array
    setCompensationItems(updatedItems);
  }
  function handleNoteChange(index: number, value: string) {
    // Create a new copy of the compensationItems array
    const updatedItems = [...OutcomeItems];
    
    // Update the note for the specific item
    updatedItems[index] = {
      ...updatedItems[index],
      note: value,
    };
  
    // Update the state with the modified array
    setOutcomeItems(updatedItems);
  }

  function handleItemNoteChange(index: number, value: string) {
    // Create a new copy of the compensationItems array
    const updatedItems = [...ItemCost];
    
    // Update the note for the specific item
    updatedItems[index] = {
      ...updatedItems[index],
      note: value,
    };
  
    // Update the state with the modified array
    setItemCost(updatedItems);
  }
  
  const handleFinish = () =>{
    try{if (compensationItems.length == 0
      ||OutcomeItems.length == 0
      ||ItemCost.length == 0
    ){
      new TypeError("พบค่าว่างในข้อความของท่าน")
    }
    const data = {
      part:'part5',
      Compensation:
      {compensationItems:compensationItems},
      Outcome:{
        OutcomeItems
      },
      ItemExpense:{
        ItemCost
      },
      reference:content
    }
    console.log(data)
    try{
      axios.patch(`${process.env.REACT_APP_BASE}/UpdateBudgetReq/${project_id}`,data)
      .then((response)=>{
          if(response.status){
            console.log("บันทึกสำเร็จ")
            console.log(response);
            navigate(`/VRIIS/BudgetReqInfo/${project_id}`)
          }
      }).catch((error)=>{
        console.log(error)
        console.log(error.response)
        notification.error({
            message: "บันทึกข้อมูลไม่สำเร็จ",
            description: error.response.data.Message,
        });
    })
    }catch{
      notification.error({
        message: "บันทึกข้อมูลไม่สำเร็จ",
        description: "มีค่าว่างอยู่ในข้อมูลของคุณ",
    })
    }
  }catch{
    notification.error({
      message: "บันทึกข้อมูลไม่สำเร็จ",
      description: "มีค่าว่างอยู่ในข้อมูลของคุณ",
  })
  }}

  const handlethisFinish = () =>{
    try{if (compensationItems.length == 0
      ||OutcomeItems.length == 0
      ||ItemCost.length == 0
    ){
      new TypeError("พบค่าว่างในข้อความของท่าน")
    }
    let data = {}
    if(project_type=='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา'){
      data = {
        part:'part5',
        budget_type:project_type,
        reference:content
      }
    }else{
      data = {
        part:'part5',
        budget_type:project_type,
        Compensation:
          {compensationItems:compensationItems},
        Outcome:{
          OutcomeItems
        },
        ItemExpense:{
          ItemCost
        },
        reference:content
      }
    }
    console.log(data)
    try{
      axios.patch(`${process.env.REACT_APP_BASE}/UpdateBudgetReq/${project_id}`,data)
      .then((response)=>{
          if(response.status){
            notification.success({
              message: "บันทึกข้อมูลสำเร็จ",
          });
          }
      }).catch((error)=>{
        console.log(error)
        console.log(error.response)
        notification.error({
            message: "บันทึกข้อมูลไม่สำเร็จ",
            description: error.response.data.Message,
        });
    })
    }catch{
      notification.error({
        message: "บันทึกข้อมูลไม่สำเร็จ",
        description: "มีค่าว่างอยู่ในข้อมูลของคุณ",
    })
    }
  }catch{
    notification.error({
      message: "บันทึกข้อมูลไม่สำเร็จ",
      description: "มีค่าว่างอยู่ในข้อมูลของคุณ",
  })
  }}

  // Function to calculate total for each budget type
  const calculateTotalByType = (x:any,type: any) => {
    return x
      .filter((item: { BudgetType: any; }) => item.BudgetType === type)
      .reduce((total: any, item: { Budget: any; }) => total + (item.Budget || 0), 0);
};
  
  
  const totalMonetary = calculateTotalByType(compensationItems,'ตัวเงิน(เบิกจ่าย)');
  const totalNonMonetary = calculateTotalByType(compensationItems,'ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้');
  const totalIndirect = calculateTotalByType(compensationItems,'ไม่เป็นตัวเงิน(งบอ้อม)');

  const OutcometotalMonetary = calculateTotalByType(OutcomeItems,'ตัวเงิน(เบิกจ่าย)');
  const OutcometotalNonMonetary = calculateTotalByType(OutcomeItems,'ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้');
  const OutcometotalIndirect = calculateTotalByType(OutcomeItems,'ไม่เป็นตัวเงิน(งบอ้อม)');

  const ItemtotalMonetary = calculateTotalByType(ItemCost,'ตัวเงิน(เบิกจ่าย)');
  const ItemtotalNonMonetary = calculateTotalByType(ItemCost,'ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้');
  const ItemtotalIndirect = calculateTotalByType(ItemCost,'ไม่เป็นตัวเงิน(งบอ้อม)');
  
  const Monetarytotal = totalMonetary + OutcometotalMonetary + ItemtotalMonetary
  const NonMonetarytotal = totalNonMonetary + OutcometotalNonMonetary + ItemtotalNonMonetary
  const IndirectTotal = totalIndirect + OutcometotalIndirect + ItemtotalIndirect
  const totalAll = Number(totalCompensation) + Number(totalOutcome) + Number(totalItemCost)

  let researcherFund = Math.min(Monetarytotal * 0.3, 50000);

  const getdata = async() =>{
    axios.get(`${process.env.REACT_APP_BASE}/BudgetReqInfo/${project_id}/${sessionStorage.getItem('user')}`).then(response=>{
      console.log(response.data)
      if(response.data.main[0].reference){
        setContent(response.data.main[0].reference)
      }
      
      if(response.data.compensation&&response.data.outcome&&response.data.itemexpense){
        setCompensationItems(
          response.data.compensation
        );
        setOutcomeItems(
          response.data.outcome.map((item: { BudgetDetail: string; Budget: number; itemAmount: any; }) => ({
            ...item,
            itemAmount:
              item.BudgetDetail === "ค่าบันทึกข้อมูล"
                ? item.Budget / 0.5
                : item.BudgetDetail === "ค่าเก็บแบบสอบถาม"
                ? item.Budget / 20
                : item.itemAmount, // Keep the existing itemAmount if it doesn't match the conditions
          }))
        );
        
        setItemCost(response.data.itemexpense)
      }
      if(response.data.ToolDraft.length>0){
        setFilename(response.data.ToolDraft[0].fileName)

      }

      if(response.data.main[0].budget_type){
        setProject_type(response.data.main[0].budget_type)
      }
    })
  }
  

  const fetchFiles = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BASE}/files/${project_id}`);
      const files = response.data.map((file: any) => ({
        uid: file.uid || `__AUTO__${file.uid}`, // Ensure each file has a unique uid
        name: decodeURIComponent(atob(file.Filename)), // Decode the filename
        status: 'done', // Mark the file as already uploaded
        url: `${process.env.REACT_APP_BASE}/get_pdf/${file.uid}`, 
        preview: file.Data
      }));
      setFileList(files);
      console.log(files)
    } catch (error) {
      console.error('Error fetching file list:', error);
    }
  };
  
  const handlePreview = (file: UploadFile) => {
    if (file.preview && (file.preview as any).data) {
      // Access the data array from the preview buffer
      const uint8Array = new Uint8Array((file.preview as any).data);
      const blob = new Blob([uint8Array], { type: 'application/pdf' });
      const blobUrl = URL.createObjectURL(blob);
  
      setPreviewUrl(blobUrl);
      setOpenFile(true);  // Open the modal
    } else {
      console.error("Preview data not found.");
    }
  };
  
    useEffect(()=>{
      getdata();
      fetchFiles();
  },[]);

    return(
        <div style={{
          padding:15
        }}>
          <h1 className="text-3xl font-semibold ">แบบฟอร์มเสนอโครงการงานวิจัยและนวัตกรรม</h1>  
      <p>เพื่อขอรับเงินทุนสนับสนุนงานวิจัยและนวัตกรรมจากมหาวิทยาลัยวงษ์ชวลิตกุล</p>
          <br/>
          <hr/>
          <br/>
            <h2 className="text-3xl font-bold ">ส่วนที่ 5 งบประมาณและค่าใช้จ่าย</h2>
            <hr/>
            <br/>
            <p className="font-semibold"><u>แบบฟอร์มแยกประเภทตามหมวดเงินงบประมาณ</u></p>
            
            <Form 
            style={{marginTop:50,marginBottom:50,marginLeft:50}}
            form={form}
            >
              <p>ประเภทของงานวิจัย:{project_type}</p>
              {project_type!='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา'&&
              <Card style={{backgroundColor: '#F7DCB9' }}>
              <Card style={{ marginLeft: 20, marginRight: 20, marginBottom: 25, backgroundColor: 'white' }}>
                <p className='font-semibold'>หมวดค่าตอบแทน</p>
                  {
                   compensationItems.map((item, index) => {
                              // Collect all selected values except the current one (to allow re-selection in the same select)
                              const selectedOptions = compensationItems
                                .filter((_, i) => i !== index) // Exclude the current index
                                .map(item => item.BudgetDetail); // Collect selected BudgetDetails

                              // Filter the available options to exclude selected ones
                              const availableOptions = option1.filter(option => 
                                !selectedOptions.includes(option.value)|| 
                                option.value === 'ค่าตอบแทนอื่นๆ');

                              return (
                                <React.Fragment key={index}>
                                  <Space style={{ display: 'flex', marginBottom: 2,justifyContent: 'center', alignItems: 'center'  }} align="baseline">
                                    <Select
                                      placeholder='โปรดเลือกหมวดหมู่ย่อย'
                                      options={availableOptions} // Use filtered options
                                      onChange={(value) => handleDetailChange(index, value)}
                                      style={{ width: '20vw', marginBottom: 10, marginTop: 10 }}
                                      value={item.BudgetDetail || null} // Ensure the select shows the current value
                                    />
                                    <Select
                                      style={{ width: '20vw' }}
                                      placeholder='เลือกประเภทของงบประมาณของท่าน'
                                      value={
                                        // item.BudgetDetail === "ค่าตอบแทนผู้เชี่ยวชาญ"
                                        //   ? "ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้"
                                        //   : item.BudgetType || null
                                        item.BudgetType || null
                                      }
                                      options={[
                                        { label: 'ตัวเงิน(เบิกจ่าย)', value: 'ตัวเงิน(เบิกจ่าย)' },
                                        { label: 'ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้', value: 'ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้' },
                                        { label: 'ไม่เป็นตัวเงิน(งบอ้อม)', value: 'ไม่เป็นตัวเงิน(งบอ้อม)' }
                                      ]}
                                      onChange={(value) => handleTypeChange(index, value)}
                                      // disabled={item.BudgetDetail === "ค่าตอบแทนผู้เชี่ยวชาญ"}
                                    />
                                    <Input
                                          placeholder="งบประมาณ"
                                          type="number"
                                          step="0.01" // Ensure two decimal places are allowed
                                          suffix='บาท'
                                          value={item.Budget}
                                          style={{ width: '10vw' }}
                                          onChange={(e) => {
                                            let value = e.target.value;
                                            let max;

                                            // Allow empty input
                                            if (value === "") {
                                              handleAmountChange(index, "");
                                              return;
                                            }

                                            // Ensure input matches a valid floating number pattern
                                            if (!/^\d+(\.\d{0,2})?$/.test(value)) {
                                              return; // Ignore invalid input
                                            }

                                            // Convert value to float
                                            let floatValue = parseFloat(value);

                                            // Define max based on BudgetDetail
                                            switch (item.BudgetDetail) {
                                              case 'ค่าตอบแทนที่ปรึกษา':
                                                max = 2000;
                                                break;
                                              case 'ค่าตอบแทนผู้เชี่ยวชาญ':
                                                max = 3000;
                                                break;
                                              case 'ค่าตอบแทนผู้เชี่ยวชาญตรวจประเมินคุณภาพเครื่องมือ':
                                                max = 2500;
                                                break;

                                              default:
                                                max = Infinity;
                                            }

                                            // Validate range
                                            if (floatValue < 0 || floatValue > max) {
                                              return;
                                            }

                                            // Ensure the correct decimal format (preserving `.0` or `.00`)
                                            let formattedValue = value.includes(".")
                                              ? parseFloat(value).toFixed(value.split(".")[1].length === 1 ? 1 : 2)
                                              : parseFloat(value).toFixed(2);

                                            // Update state
                                            handleAmountChange(index, formattedValue);
                                          }}
                                        />

                                    <MinusCircleOutlined onClick={() => handleRemoveCompensation(index)} />
                                  </Space>
                                  {item.BudgetDetail === 'ค่าตอบแทนที่ปรึกษา' && (
                                    <p style={{ color: 'red',  }}>มีได้ 1 ท่าน งบประมาณ 2,000 บาทต่อคน</p>
                                  )}
                                  {item.BudgetDetail === 'ค่าตอบแทนผู้เชี่ยวชาญตรวจประเมินคุณภาพเครื่องมือ' && (
                                    <p style={{ color: 'red',  }}>มีได้ไม่เกิน 5 ท่าน งบประมาณ 500 บาทต่อคน</p>
                                  )}
                                  {item.BudgetDetail === 'ค่าตอบแทนผู้เชี่ยวชาญ' && (
                                    <p style={{ color: 'red',  }}>ค่าตอบแทนผู้เชี่ยวชาญประเมินรายงานวิจัยฉบับสมบูรณ์ 2 ท่าน ท่านละ 1500 บาท</p>
                                  )}
                                  {/* {item.BudgetDetail === 'ค่าตอบแทนผู้วิจัย' && (
                                    <p style={{ color: 'red',  }}>ร้อยละ 30 ของงบตรง แต่ไม่เกิน 50,000 บาท</p>
                                  )} */}
                                  {
                                    (item.BudgetDetail==="ค่าตอบแทนอื่นๆ")
                                    &&
                                    <><Space style={{ display: 'flex', marginBottom: 2,justifyContent: 'center', alignItems: 'center' }}></Space>
                                        <TextArea
                                          style={{ width: '50vw' }}
                                          value={item.note}
                                          placeholder="หมายเหตุ"
                                          onChange={(e) => handleCompensationNoteChange(index, e.target.value)}
                                          autoSize
                                        />
                                      </>
                                  }
                                </React.Fragment>
                              );
                            })
                          }
                <Flex justify='flex-end' style={{ marginRight: 40 }}>
                  <p>ผลรวมการเบิกงบประมาณเป็นตัวเงิน : {formatNumber(totalMonetary)} บาท</p>
                </Flex>
                <Flex justify='flex-end' style={{ marginRight: 40 }}>
                  <p>ผลรวมการเบิกงบประมาณแบบไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้ : {formatNumber(totalNonMonetary)} บาท</p>
                </Flex>
                <Flex justify='flex-end' style={{ marginRight: 40 }}>
                  <p>ผลรวมการเบิกงบประมาณไม่เป็นตัวเงิน(งบอ้อม) : {formatNumber(totalIndirect)} บาท</p>
                </Flex>
                <Flex justify='flex-end'>
                  <p style={{ marginRight: 40 }}>ผลรวม : {formatNumber(totalCompensation)} บาท</p>
                </Flex>

                {/* Keep the Form.Item and Button inside the Card */}
                <Form.Item>
                  <Button type="dashed" onClick={handleAddCompensation} block icon={<PlusOutlined />}>
                    เพิ่มข้อมูล
                  </Button>
                </Form.Item>
              </Card>

                <Card style={{marginLeft:20,marginRight:20,marginBottom:25,backgroundColor: 'white'}}>
              <p className='font-semibold'>หมวดค่าใช้จ่าย</p>
              {
                OutcomeItems.map((item, index) => {
                  // Get already selected values, except for 'ค่าใช้จ่ายอื่น ๆ ที่เกิดขึ้นจริงตามความเหมาะสม'
                  const selectedValues = OutcomeItems
                    .map((outcome) => outcome.BudgetDetail)
                    .filter((val) => val !== 'ค่าใช้จ่ายอื่น ๆ ที่เกิดขึ้นจริงตามความเหมาะสม');

                  return (
                    <React.Fragment key={index}>
                      
                      <Space style={{ display: 'flex', marginBottom: 2,justifyContent: 'center', alignItems: 'center' }} align="baseline">
                        <Select
                          placeholder={'โปรดเลือกหมวดหมู่ย่อย'}
                          options={option2.filter(option => 
                            !selectedValues.includes(option.value) || 
                            option.value === 'ค่าใช้จ่ายอื่น ๆ ที่เกิดขึ้นจริงตามความเหมาะสม'
                          )}
                          onChange={(value) => handleOutcomeDetailChange(index, value)}
                          style={{ width: '20vw', marginBottom: 10, marginTop: 10 }}
                          value={item.BudgetDetail|| null}
                        />
                        <Select
                          style={{width:'35vh'}}
                          placeholder='เลือกประเภทของงบประมาณของท่าน'
                          value={item.BudgetType|| null}
                          disabled={item.BudgetDetail=='ค่าไปนำเสนอผลงานวิจัยและนวัตกรรม'}
                          options={[
                            {
                              label:'ตัวเงิน(เบิกจ่าย)',
                              value:'ตัวเงิน(เบิกจ่าย)'
                            },{
                              label:'ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้',
                              value:'ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้'
                            },{
                              label:'ไม่เป็นตัวเงิน(งบอ้อม)',
                              value:'ไม่เป็นตัวเงิน(งบอ้อม)'
                            }
                          ]}
                          onChange={(value)=>handleOutcomeTypeChange(index,value)}
                          />
                        {item.BudgetDetail=='ค่าบันทึกข้อมูล'&&
                        <InputNumber
                        value={item.itemAmount}
                        style={{ width: '20vh' }}
                        suffix="หน้า"
                        onChange={(value) => {
                          // ตรวจสอบว่า input ไม่มีจุด (.)
                          if(item.Budget!=0 ||item.Budget!=undefined ){
                            item.itemAmount = item.Budget/0.5
                          }
                          if (value && !String(value).includes('.')) {
                            let Amount = value;
                      
                            // ป้องกันไม่ให้มีค่าทศนิยม
                            if (Amount !== undefined && Amount !== null) {
                              Amount = Math.floor(Number(Amount)); // หรือใช้ parseInt(Amount)
                      
                              const newItems = [...OutcomeItems];
                              newItems[index].itemAmount = Amount || 0;
                              newItems[index].Budget = Amount * 0.5 || 0;
                              setOutcomeItems(newItems);
                            }
                          }
                        }}
                      />
                        ||item.BudgetDetail=='ค่าเก็บแบบสอบถาม'&&
                        <InputNumber
                          value={item.itemAmount}
                          style={{ width: '20vh' }}
                          suffix="ชุด"
                          onChange={(value) => {
                            if(item.Budget!=0 ||item.Budget!=undefined ){
                              item.itemAmount = item.Budget/20
                            }
                            
                            let Amount = value;

                            if (Amount !== undefined && Amount !== null) {
                              const newItems = [...OutcomeItems];
                              newItems[index].itemAmount = Number(Amount) || 0;
                              newItems[index].Budget = Number(Amount * 20) || 0;
                              setOutcomeItems(newItems);
                            }
                          }}
                        />
                        ||
                        <Input
                          placeholder="งบประมาณ"
                          type="number"
                          value={item.Budget}
                          suffix='บาท'
                          step="1.00" // Allow decimal input
                          style={{ width: '20vh'}}
                          onChange={(e) => {
                            const value = e.target.value;
                            const trimmedValue = value.match(/^\d+(\.\d{0,2})?$/) ? value : parseFloat(value).toFixed(2); // Ensure only 2 decimals
                            let max;

                            switch(item.BudgetDetail){
                              case 'ค่าจัดทำรูปเล่ม':
                                max = 600;
                                break;
                              case 'ค่าใช้จ่ายในการขอจริยธรรมการวิจัย':
                                max = 2500;
                                break;
                              default:
                                max = Infinity;
                                break;
                            }

                            const floatValue = parseFloat(value);

                            if ((floatValue >= 0 && floatValue <= max) || value === "") {
                              handleOutcomeAmountChange(index, trimmedValue); // Pass the value up
                            }
                          }}
                        />}
                        <MinusCircleOutlined onClick={() => handleRemoveOutcome(index)} />
                      </Space>
                      
                      
                      <>
                        {item.BudgetDetail === 'ค่าบันทึกข้อมูล' &&
                          <><Flex justify='space-between'>
                            <p style={{ color: 'red' ,justifyContent: 'center', alignItems: 'center'}}>หน้าละ 0.50 บาท</p>
                            <p>จำนวนเงินสุทธิ : {item.Budget}</p>
                            </Flex></>}
                        {item.BudgetDetail === 'ค่าใช้จ่ายในการขอจริยธรรมการวิจัย' &&
                          <><p style={{ color: 'red',justifyContent: 'center', alignItems: 'center' }}>ไม่เกิน 2,500 บาท</p></>}
                        {item.BudgetDetail === 'ค่าจัดทำรูปเล่ม' &&
                          <><p style={{ color: 'red',justifyContent: 'center', alignItems: 'center' }}>2 เล่ม เล่มละไม่เกิน 300 บาท </p></>}

                        {item.BudgetDetail === 'ค่าเก็บแบบสอบถาม' &&
                          <><Flex justify='space-between'><p style={{ color: 'red',justifyContent: 'center', alignItems: 'center' }}>งบประมาณกำหนดที่ 20 บาทต่อชุด</p>
                          <p>จำนวนเงินสุทธิ : {item.Budget}</p>
                          </Flex></>}
                        {(item.BudgetDetail === 'ค่าใช้จ่ายอื่น ๆ ที่เกิดขึ้นจริงตามความเหมาะสม'
                        ||item.BudgetDetail === 'ค่าบันทึกข้อมูล'
                        ||item.BudgetDetail === 'ค่าเก็บแบบสอบถาม'
                      )
                         && (
                          <><Space style={{ display: 'flex', marginBottom: 2,justifyContent: 'center', alignItems: 'center' }}></Space>
                            <TextArea
                              style={{ width: '50vw' }}
                              value={item.note}
                              placeholder="หมายเหตุ"
                              onChange={(e) => handleNoteChange(index, e.target.value)}
                              autoSize
                            />
                          </>
                        )}
                      </>
                     
                    </React.Fragment>
                  );
                })
              }
              
              <>
              <Flex justify='flex-end' style={{marginRight:40}}>
                <p>ผลรวมการเบิกงบประมาณเป็นตัวเงิน : {formatNumber(OutcometotalMonetary)} บาท</p></Flex>
              <Flex justify='flex-end' style={{marginRight:40}}>
                <p>ผลรวมการเบิกงบประมาณแบบไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้ : {formatNumber(OutcometotalNonMonetary)} บาท</p>
              </Flex>
              <Flex justify='flex-end' style={{marginRight:40}}>
                <p>ผลรวมการเบิกงบประมาณไม่เป็นตัวเงิน(งบอ้อม) : {formatNumber(OutcometotalIndirect)} บาท</p>
              </Flex>
              <Flex justify='flex-end' style={{marginRight:40}} >
                ผลรวม :  {formatNumber(totalOutcome)} บาท</Flex>
              <Form.Item>
                  <Button type="dashed" onClick={handleAddOutcome} block icon={<PlusOutlined />}>
                    เพิ่มข้อมูล
                  </Button>
                </Form.Item>
              </>
            </Card>
              <Card style={{ marginLeft: 20, marginRight: 20, marginBottom: 25, backgroundColor: 'white' }}>
                <p className='font-semibold'>หมวดค่าวัสดุ และอุปกรณ์</p>
                  {
                    ItemCost.map((item, index) => {
                      // Get already selected values, except for 'ค่าวัสดุอื่น ๆ'
                      const selectedItemValues = ItemCost
                        .map((cost) => cost.BudgetDetail)
                        .filter((val) => val !== 'ค่าวัสดุอื่น ๆ');

                      return (
                        <React.Fragment key={index}>
                          <Space style={{ display: 'flex', marginBottom: 2,justifyContent: 'center', alignItems: 'center' }} align="baseline">
                            <Select
                              placeholder={'โปรดเลือกหมวดหมู่ย่อย'}
                              options={option3.filter(option =>
                                !selectedItemValues.includes(option.value) || 
                                option.value === 'ค่าวัสดุอื่น ๆ'
                              )}
                              onChange={(value) => handleitemcostBudgetDetailChange(index, value)}
                              style={{ width: '20vw', marginBottom: 10, marginTop: 10 }}
                              value={item.BudgetDetail|| null}
                            />
                            
                            <Select
                            style={{width:'35vh'}}
                            placeholder='เลือกประเภทของงบประมาณของท่าน'
                            value={item.BudgetType|| null}
                            options={[
                              {
                                label:'ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้',
                                value:'ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้'
                              },{
                                label:'ไม่เป็นตัวเงิน(งบอ้อม)',
                                value:'ไม่เป็นตัวเงิน(งบอ้อม)'
                              }
                            ]}
                            onChange={(value)=>handleItemsTypeChange(index,value)}
                          />
                            <Input
                              placeholder="งบประมาณ"
                              type="number"
                              step="1.00" // Allow decimal input
                              value={item.Budget}
                              style={{ width: '20vh'}}
                              onChange={(e) => {
                                const value = e.target.value;
                                const trimmedValue = value.match(/^\d+(\.\d{0,2})?$/) ? value : parseFloat(value).toFixed(2); // Ensure only 2 decimals
                                // Only update if the value is positive or zero
                                if (item.BudgetDetail === 'ค่าวัสดุ และอุปกรณ์การวิจัย' ||
                                    item.BudgetDetail === 'ค่าวัสดุอื่น ๆ' ||
                                    item.BudgetDetail === 'ค่าผลิตรายงานการวิจัยต้นฉบับ' ||
                                    item.BudgetDetail === 'ค่าผลิตเอกสาร / แบบสอบถาม / งานวิจัยที่เกี่ยวข้อง') {
                                  if (parseFloat(value) >= 0 || value === "") {
                                    handleItemAmountChange(index, trimmedValue);
                                  }
                                } else if (item.BudgetDetail === 'ค่าแฟลชไดรฟ์') {
                                  if ((parseFloat(value) >= 0 && parseFloat(value) <= 300) || value === "") {
                                    handleItemAmountChange(index, trimmedValue);
                                  }
                                }
                              }}
                            />
                            <MinusCircleOutlined onClick={() => handleRemoveItem(index)} />
                          </Space>
                          <>
                            {item.BudgetDetail === 'ค่าแฟลชไดรฟ์' && (
                              <p style={{ color: 'red' }}>เบิกได้ 2 อัน อันละ 150 บาท</p>
                            )}
                            {(item.BudgetDetail === 'ค่าวัสดุอื่น ๆ'|| item.BudgetDetail === 'ค่าวัสดุ และอุปกรณ์การวิจัย' )&& (
                              <TextArea
                                value={item.note}
                                style={{ width: '50vw' }}
                                placeholder="หมายเหตุ"
                                onChange={(e) => handleItemNoteChange(index, e.target.value)}
                                autoSize
                              />
                            )}
                          </>
                        </React.Fragment>
                      )
                    })
                  }
                  <>
                 
                  <Flex justify='flex-end' style={{marginRight:40}}>
                    <p>ผลรวมการเบิกงบประมาณแบบไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้ : {formatNumber(ItemtotalNonMonetary)} บาท</p>
                  </Flex>
                  <Flex justify='flex-end' style={{marginRight:40}}>
                    <p>ผลรวมการเบิกงบประมาณไม่เป็นตัวเงิน(งบอ้อม) : {formatNumber(ItemtotalIndirect)} บาท</p>
                  </Flex>
                  <Flex justify='flex-end' style={{marginRight:40}}>
                    ผลรวม : {formatNumber(totalItemCost)} บาท</Flex>
                    <Form.Item>
                      <Button type="dashed" onClick={handleAddItemCost} block icon={<PlusOutlined />}>
                        เพิ่มข้อมูล
                      </Button>
                    </Form.Item>
                  </>
                </Card>
              </Card>
              ||
              <Card style={{backgroundColor: '#F7DCB9' }}>
                <Card style={{ marginLeft: 20, marginRight: 20, marginBottom: 25, backgroundColor: 'white', textAlign: 'center', }} >
                  <p>คุณไม่สามารถกรอกงบประมาณวิจัยได้เนื่องจากโครงการของคุณมีประเภททุนเป็น ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา</p>
                </Card>
              </Card>}
              <br/>
            </Form>
           
           {project_type!='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา'&&
           <Card style={{marginTop:50,marginBottom:50,marginLeft:50}}>
            <Flex justify='center'><p className='font-semibold text'><u>ผลรวมงบประมาณ</u></p></Flex>
            <br/>
            <Table
              rowKey="id"
              columns={[
                {
                  title: 'รายละเอียดประมาณการค่าใข้จ่าย',
                  width: 450,
                  dataIndex: 'detail',
                  key: 'detail',
                  render: (_, record) => (
                    <>
                      {record.detail === 'รวม' ? (
                        <p className="font-semibold">{record.detail}</p>
                      ) : (
                        <p>{record.detail}</p>
                      )}
                    </>
                  ),
                },
                {
                  title: 'งบประมาณ',
                  width: 1000,
                  children: [
                    {
                      title: 'ตัวเงิน(เบิกจ่าย)',
                      dataIndex: 'MonetrySum',
                      width: 200, // Ensure this matches expanded table
                      render: (_, record) => (
                        <Flex justify="center">
                          {record.detail === 'รวม' ? (
                            <p className="font-semibold">
                              {formatNumber(Number(record.MonetrySum))}
                            </p>
                          ) : (
                            <p>{formatNumber(Number(record.MonetrySum))}</p>
                          )}
                        </Flex>
                      ),
                    },
                    {
                      title: 'ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้',
                      dataIndex: 'PreparedSum',
                      width: 200, // Ensure this matches expanded table
                      render: (_, record) => (
                        <Flex justify="center">
                          {record.detail === 'รวม' ? (
                            <p className="font-semibold">
                              {formatNumber(Number(record.PreparedSum))}
                            </p>
                          ) : (
                            <p>{formatNumber(Number(record.PreparedSum))}</p>
                          )}
                        </Flex>
                      ),
                    },
                    {
                      title: 'ไม่เป็นตัวเงิน(งบอ้อม)',
                      dataIndex: 'IndirectSum',
                      width: 200, // Ensure this matches expanded table
                      render: (_, record) => (
                        <Flex justify="center">
                          {record.detail === 'รวม' ? (
                            <p className="font-semibold">
                              {formatNumber(Number(record.IndirectSum))}
                            </p>
                          ) : (
                            <p>{formatNumber(Number(record.IndirectSum))}</p>
                          )}
                        </Flex>
                      ),
                    },
                  ],
                },
                {
                  title: 'รวม',
                  width: 150,
                  dataIndex: 'sum',
                  render: (_, record) => (
                    <Flex justify="center">
                      {record.detail === 'รวม' ? (
                        <p className="font-semibold">{formatNumber(Number(record.sum))}</p>
                      ) : (
                        <p>{formatNumber(record.sum)}</p>
                      )}
                    </Flex>
                  ),
                },
                {
                  title: 'หมายเหตุ',
                  dataIndex: 'note',
                  key: 'note',
                  render: (text) => <div style={{ maxWidth: '500px' }}>{text}</div>,
                },
              ]}
              dataSource={[
                {
                  id:0,
                  detail:'หมวดค่าตอบแทน',
                  MonetrySum: totalMonetary,
                  PreparedSum: totalNonMonetary,
                  IndirectSum: totalIndirect,
                  sum: totalCompensation
                },
                {
                  id:1,
                  detail:'หมวดค่าใช้จ่าย',
                  MonetrySum: OutcometotalMonetary,
                  PreparedSum:OutcometotalNonMonetary,
                  IndirectSum:OutcometotalIndirect,
                  sum:totalOutcome
                },
                {
                  id:2,
                  detail:'หมวดค่าวัสดุ และอุปกรณ์',
                  MonetrySum: ItemtotalMonetary,
                  PreparedSum:ItemtotalNonMonetary,
                  IndirectSum:ItemtotalIndirect,
                  sum:totalItemCost
                },
                {
                  id:4,
                  detail:'รวม',
                  MonetrySum: Monetarytotal,
                  PreparedSum:NonMonetarytotal,
                  IndirectSum:IndirectTotal,
                  sum:totalAll
                },
              ]}
              expandable={{
                expandedRowRender,
                expandedRowKeys,
                onExpand: handleExpand,
                rowExpandable: (record) => {
                  switch (record.detail) {
                    case 'หมวดค่าตอบแทน':
                      return compensationItems?.length > 0;
                    case 'หมวดค่าใช้จ่าย':
                      return OutcomeItems?.length > 0;
                    case 'หมวดค่าวัสดุ และอุปกรณ์':
                      return ItemCost?.length > 0;
                    default:
                      return false;
                  }
                },
              }}
              pagination={false}
              scroll={{ x: 'max-content' }}
              locale={{
                emptyText: <Empty description="ยังไม่มีข้อมูลในตาราง" />,
              }}
            />

            
           </Card>}
            <hr/>
            <Form.Item  label='บรรณานุกรม (ใช้รูปแบบการเขียนบรรณานุกรมแบบ APA style)' layout="vertical">
            <p style={{ fontSize: '17px', marginLeft: 20 }}>กรุณากรอกเป็นข้อความเท่านั้น</p>
            <CKEditors  myRef={ref} htmlBox={content} onBlur={handleLiteratureEditorChange} toolstate={true} />
            </Form.Item>
            <br/>
            
            <Form.Item label="ร่างเครื่องมือการวิจัย (แนบไฟล์ PDF/ไม่จำเป็นต้องอัพโหลด)">
                <Upload {...props} 
                beforeUpload={beforeUpload}
                >
                    <Button icon={<UploadOutlined />}>กดเพื่ออัพโหลดไฟล์</Button>
                </Upload>
            </Form.Item>
            <p className='font-semibold'>ไฟล์ที่อยู่ในระบบ</p>
            <List
              bordered
              dataSource={fileList}
              renderItem={(file) => (
                <List.Item
                  actions={[
                    <>
                      <Button type='link' onClick={() => DownloadHandle(file.uid)}>Download</Button>
                      <Button onClick={() =>{ console.log(file)
                        handleRemove(file.uid, file.fileName)}} type="link">Remove</Button>
                    </>
                  ]}
                >
                  <Button type='link' 
                  onClick={() => handlePreview(file)}>{file.name}</Button>
                  
                  <Modal
                   onCancel={()=>setOpenFile(false)}
                   style={{ width: 50000, height: 500 }}
                    open={openfile}
                    footer={<><Button onClick={()=>setOpenFile(false)} >ปิด</Button></>}
                    bodyStyle={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }} // Centering content
                  >
                    <br/>
                    {previewUrl ? (
                      <iframe
                        src={previewUrl}
                        width="100%"
                        height="600px"
                        title="PDF Viewer"
                      />
                    ) : (
                      <p>Loading...</p>
                    )}
                    
                  </Modal>
                </List.Item>
              )}
            />
            <br/>
            <Flex justify="space-between" align="center" style={{ width: '100%' }}>
              <div style={{ flex: 1, textAlign: 'left' }}>
              <Button type="primary" onClick={()=>{setopen(true)}}>กลับไปหน้าก่อน</Button>
              
              </div>
              <Modal
              title="ยืนยันการกลับไปหน้าก่อน"
              width={'50vw'}
              open={open}
              onCancel={handleCancel}
              footer={[
                <><Button key="back" onClick={handleCancel}>
                  ยกเลิก
                </Button>
                <Button  key="go" danger type="primary" href={`/VRIIS/BudgetReqResult/${project_id}`}>
                  ตกลง
                </Button>
                </>
              ]}>
              การตกลงจะนำทางท่านไปสู่ส่วนก่อนหน้านี้โดยไม่บันทึกข้อมูลที่ท่านกรอกไปแล้ว ท่านมั่นใจหรือไม่ที่จะกลับไปส่วนก่อน
              </Modal>
              <div style={{ flex: 1, textAlign: 'center' }}>
              <Button type="primary"
              style={{
                backgroundColor: '#33b249',
                color: 'white',
                borderColor: '#33b249',
              }}
               onClick={handlethisFinish}>บันทึกและอยู่ในหน้านี้</Button>
              </div>
              <div style={{ flex: 1, textAlign: 'right' }}>
                <Flex justify="flex-end"><Button type="primary" onClick={handleFinish}>บันทึกแล้วกลับหน้าหลัก</Button></Flex>
              </div>
            </Flex>
            
        </div>
    )
}